<template>
  <div class="animated fadeIn">
    <!-- Basic Information -->
    <b-card-header>
      Basic Information
      <div class="card-header-actions">
        <a class="card-header-action" href="transaction-addons" rel="noreferrer noopener">
          <small class="text-muted">Back</small>
        </a>
      </div>
    </b-card-header>
    <b-card>
      <b-row class="mb-4">
        <b-col sm="4">
          <h6 class="title-content">Add On Code</h6>
          <p class="content-text">{{ this.data.basic_information.add_on_code }}</p>
        </b-col>
        <b-col sm="4">
          <h6 class="title-content">Add On Name</h6>
          <p class="content-text">{{ this.data.basic_information.add_on_name }}</p>
        </b-col>
        <b-col sm="4">
          <h6 class="title-content">Invoice Number</h6>
          <p class="content-text">{{ this.data.basic_information.invoice_number }} <span class="fa fa-copy icon-copy" @click="copyToClipboard"></span></p>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="4">
          <h6 class="title-content">Name</h6>
          <p class="content-text">{{ this.data.basic_information.user_name }}</p>
        </b-col>
        <b-col sm="4">
          <h6 class="title-content">Email</h6>
          <p class="content-text">{{ this.data.basic_information.user_email }}</p>
        </b-col>
      </b-row>
    </b-card>
    <!-- Detail Information -->
    <b-card-header>
      Detail Information
    </b-card-header>
    <b-card>
      <b-row class="mb-4">
        <b-col sm="4">
          <h6 class="title-content">Total Amount</h6>
          <p class="content-text">{{ this.data.detail_information.total_amount }}</p>
        </b-col>
        <b-col sm="4">
          <h6 class="title-content">Unit Value</h6>
          <p class="content-text">{{ this.data.detail_information.unit_value }}</p>
        </b-col>
        <b-col sm="4">
          <h6 class="title-content">Gross Amount</h6>
          <p class="content-text">{{ this.data.detail_information.gross_amount }}</p>
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col sm="4">
          <h6 class="title-content">Buying Rate</h6>
          <p class="content-text">{{ this.data.detail_information.buying_rate }}</p>
        </b-col>
        <b-col sm="4">
          <h6 class="title-content">Selling Rate</h6>
          <p class="content-text">{{ this.data.detail_information.selling_rate }}</p>
        </b-col>
        <b-col sm="4">
          <h6 class="title-content">Tax Amount</h6>
          <p class="content-text">{{ this.data.detail_information.tax_amount }}</p>
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col sm="4">
          <h6 class="title-content">Created Date</h6>
          <p class="content-text">{{ this.data.detail_information.created_at }}</p>
        </b-col>
        <b-col sm="4">
          <h6 class="title-content">Updated Date</h6>
          <p class="content-text">{{ this.data.detail_information.updated_at }}</p>
        </b-col>
        <b-col sm="4">
          <h6 class="title-content">Discount Amount</h6>
          <p class="content-text">{{ this.data.detail_information.discount_amount }}</p>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import axios from  'axios'

export default {
  name: 'detail-transaction-addons',
  components: {
  },
  data() {
    return {
      data: {},
      isLoading: false,
      errors: {
        code: '',
        message: '',
        status: ''
      },
      busy:false,
    }
  },
  created () {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`
    this.onFetchDetail()
  },
  methods: {
    async onFetchDetail() {
      this.isLoading = true;
      await this.$http.get(`addons/transaction-detail?id=` + atob(this.$route.params.id))
        .then((result) => {
          this.isLoading = false;
          this.data = result.data.data;
        }).catch((error) => {
          if (error.response) {
            this.errors.code = error.response.status;
            this.errors.message = error.response.data.meta.message;
            this.errors.status = error.response.data.meta.code;
          }
        })
    },
    copyToClipboard(){
      const data = this.data.basic_information.invoice_number
      navigator.clipboard.writeText(data);
      this.$bvToast.toast('Copy To Clipboard!', {
        title: 'Info',
        variant: 'primary',
        append:true,
        autoHideDelay: '1000'
      })
    }
  }
}
</script>

<style>
  .icon-copy{
    cursor: pointer;
  }
  .icon-copy:hover{
    color: #63c2de !important;
  }

  .title-content{
    color: #606060;
  }
  .content-text{
    font-weight: bold!important;
  }
  .error-input .dropdown-toggle{
    border-color: red!important;
  }
  .error-message{
    color: #FA836B;
  }
  .text-red {
    color: #CB211F;
  }
  .text-success {
    color: #35AA4B;
  }

  /* Absolute Center Spinner */
  .loading {
    position: fixed;
    z-index: 999;
    height: 2em;
    width: 2em;
    overflow: visible;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  /* Transparent Overlay */
  .loading:before {
    content: '';
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.3);
  }
</style>
<style src="spinkit/scss/spinkit.scss" lang="scss" />
